import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const GlobalActionFeedback: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState<string | undefined>(undefined);

  useEffect(() => {
    let timer: any = null;
    const handler = (e: any) => {
      const d = e?.detail;
      if (!d) {
        setTitle(String(e?.detail || 'Success'));
        setDesc(undefined);
      } else if (typeof d === 'string') {
        setTitle(d);
        setDesc(undefined);
      } else {
        setTitle(d.title || d.content || 'Success');
        setDesc(d.description || d.content || undefined);
      }
      setVisible(true);

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => setVisible(false), 3000);
    };

    document.addEventListener('cms-feedback', handler as EventListener);
    return () => {
      document.removeEventListener('cms-feedback', handler as EventListener);
      if (timer) clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;

  const el = (
    <div style={{ position: 'fixed', right: 20, top: 20, zIndex: 9999, pointerEvents: 'auto' }}>
      <Card style={{ borderRadius: 8, boxShadow: '0 6px 20px rgba(0,0,0,0.12)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 22 }} />
          <div>
            <div style={{ fontWeight: 600 }}>{title}</div>
            {desc && <div style={{ fontSize: 12, color: 'rgba(0,0,0,0.65)' }}>{desc}</div>}
          </div>
        </div>
      </Card>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    const { createPortal } = require('react-dom');
    return createPortal(el, document.body);
  }

  return el;
};

export default GlobalActionFeedback;
